import { Site } from './site.model';
import { Timezone } from './timezone.model';

/* User defined models */
export class AppointmentSlot {
  id: string;
  href: string;
  startDateTime: Date;
  duration: number;
  site: Site;
  testTime?: any;
  testEndTime?: any;
  proctorTimeZone?: Timezone;

  constructor(
    id?: string,
    href?: string,
    startDateTime?: Date,
    duration?: number,
    site?: Site,
    testTime?: any,
    testEndTime?: any
  ) {
    this.id = id;
    this.href = href;
    this.startDateTime = startDateTime;
    this.duration = duration;
    this.site = site;
    this.testTime = testTime;
    this.testEndTime = testEndTime;
  }
}
